import { faBan, faEdit, faSave } from '@fortawesome/pro-regular-svg-icons';
import { Button } from 'src/components/Button';
import { Icon } from 'src/components/Icon';
import { IconButton } from 'src/components/IconButton';
import { Stack } from 'src/components/Stack';

interface EditButtonProps {
  editTitle?: React.ReactNode;
  saveTitle?: React.ReactNode;
  onClickEdit?: (e: React.MouseEvent) => void;
  onClickSave?: (e: React.MouseEvent) => void;
  onClickCancel?: (e: React.MouseEvent) => void;
  editing?: boolean;
  saving?: boolean;
  disabled?: boolean;
  sx?;
}

export const EditButton: React.FC<EditButtonProps> = ({
  editTitle = 'Edit',
  saveTitle = 'Save',
  onClickEdit,
  onClickCancel,
  onClickSave,
  editing = false,
  saving = false,
  disabled,
  sx,
}) => {
  return (
    <>
      {editing && (
        <Stack direction="row" spacing={2} sx={sx}>
          {onClickCancel && (
            <IconButton
              onClick={onClickCancel}
              color="info"
              disabled={disabled}
            >
              <Icon icon={faBan} />
            </IconButton>
          )}
          <Button
            color="primary"
            variant="contained"
            startIcon={<Icon icon={faSave} />}
            onClick={onClickSave}
            loading={saving}
            disabled={disabled}
          >
            {saveTitle}
          </Button>
        </Stack>
      )}
      {!editing && (
        <Button
          startIcon={<Icon icon={faEdit} />}
          variant="outlined"
          color="primary"
          onClick={onClickEdit}
          loading={saving}
          disabled={disabled}
          sx={sx}
        >
          {editTitle}
        </Button>
      )}
    </>
  );
};
